<template>
  <div class="contact">
    <Banner :banner="banner" />
    <div id="map"></div>
    <div class="container">
      <div class="one">
        <div class="list">
          <div class="item" aos="fade-top">
            <div class="top">
              <div class="img">
                <img src="/images/contact-one1.png" alt="">
              </div>
              <h3>Address</h3>
              <p><span style="font-family: arial, helvetica, sans-serif; font-size: 18px;">12th Floor, Jianchen Building, No. 99 Taihui Road, Shounan Street, Yinzhou District, Ningbo City, Zhejiang Province, China. </span></p>
            </div>
            <a target="_blank" href="https://goo.gl/maps/pRGK2N4p9a96MM4J7" >Navigation <span class="iconfont icon-jiantou_qiehuanzuo_o"></span></a>
          </div>
          <div class="item" aos="fade-top">
            <div class="top">
              <div class="img">
                <img src="/images/contact-one2.png" alt="">
              </div>
              <h3>E-mail</h3>

              <p> <a href="javascript:;" style="font-size: 18px;text-align: center;display: block;margin: auto;">info@funjoycn.com<span class="iconfont icon-jiantou_qiehuanzuo_o"></span></a></p>
            </div>
            <span style="font-family: arial, helvetica, sans-serif; font-size: 14px;text-align: center;">We Will Reply Your Email Within 24 Hours of Receipt.</span>
          </div>
          <div class="item" aos="fade-top">
            <div class="top">
              <div class="img">
                <img src="/images/contact-one3.png" alt="">
              </div>
              <h3>Telephone</h3>
              <a href="javascript:;" style="font-size: 18px; text-align: center;margin: auto;display: block">0086 574 2890 0153<span class="iconfont icon-jiantou_qiehuanzuo_o"></span></a>
              <p></p>
            </div>
            <span style="font-family: arial, helvetica, sans-serif; font-size: 14px; text-align: center">Beijing Time 9:30-18:00</span>
          </div>
        </div>
      </div>
      <div class="tow" id="md1">
        <div class="bg">
          <img src="/images/contact-tow-bg.png" alt="">
        </div>
        <div class="box">
          <div class="top">
            <h2>Get In Touch</h2>
            <p>
              Send your inquiry today, and our dedicated support team will get<br> back to you as soon as possible
              to address your concerns.
            </p>
          </div>
          <div class="bottom">
            <form action="javascript:;">
              <div class="row">
                <div class="item">
                  <input type="text" name="name" placeholder="Name">
                </div>
                <div class="item">
                  <input type="text" name="Email" placeholder="Email">
                </div>
                <div class="item">
                  <input type="text" name="Telephone" placeholder="Telephone">
                </div>
              </div>
              <div class="row">
                        <textarea name="optical" id="optical" cols="30" rows="10"
                                  placeholder="Questions/Comments (optical)"></textarea>
              </div>
              <button type="submit" class="botton">
                <span>Submit</span>
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { get_column } from '@/util/lang.js'
import Banner from '@/components/Banner.vue'
import { initMap } from './map.js'
import Scrollbar from 'smooth-scrollbar';
export default {
  components: {
    Banner
  },
  data() {
    return {
      column : '',
      banner: {
        img: "/images/locals/contactbanner.jpg",
        img_loading: "/images/locals_sm/contactbanner.jpg",
        smallimg: "/images/locals/contactbanner.jpg",
        smallimg_loading: "/images/locals/contactbanner.jpg",
        content: {
          // cn: "联系我们",
          en: "contact us"
        }
      }
    }
  },
  mounted(){
    Scrollbar.initAll();
    initMap()
  },
  methods:{
    get_content() {
      const url = get_column();
      this.$$axios.get(url).then(res => {
        this.column = res.data
        this.banner.content.en = this.column[17].description
      })
    },
  },
  created() {
    this.get_content()
  }
}
</script>

<style scoped>
.one {
  width: 1268px;
  margin: 0 auto;
  padding: 80px 0 76px;
}
.one .list {
  display: flex;
}
.one .list .item {
  flex: 1;
  border: 1px solid #EAEAEA;
  padding: 37px 0 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.one .list .item:nth-child(2n) {
  margin: 0 20px 0;
}
.one .list .item .img {
  width: 54px;
  height: 54px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.one .list .item h3 {
  color: #1f2021;
  font-size: 26px;
  margin-top: 34px;
  line-height: 1;
  transition: all 1s;
  text-align: center;
}
.one .list .item p {
  color: #2e2e2e;
  font-size: 16px;
  margin-top: 20px;
  line-height: 1;
  font-family: PingFang SC m;
  transition: all 1s;
  text-align: center;
}
.one .list .item a {
  color: #2E2E2E;
  font-size: 14PX;
  line-height: 1;
  margin-top: 34px;
  display: inline-block;
  font-family: PingFang SC r;
  display: flex;
  align-items: center;
  margin: 34px auto 0;
  transition: all 1s;
}
.one .list .item a span {
  color: #2E2E2E;
  display: inline-block;
  transform: translateX(8px) scaleX(-1);
  transition: all 1s;
}
.one .list .item a:hover span {
  transform: translateX(12px) scaleX(-1);
}
.one .list .item:hover h3,
.one .list .item:hover a {
  color: #004b94;
}
.one .list .item:hover a span {
  color: #004b94;
}
.tow {
  position: relative;
  overflow: hidden;
}
.tow .bg img {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 790px;
  display: block;
}
.tow .box {
  position: absolute;
  width: 1384px;
  left: 50%;
  transform: translateX(-50%);
  top: 121px;
  z-index: 10;
}
.tow .box .top {
  text-align: center;
}
.tow .box .top h2 {
  font-size: 42px;
  color: #292b2e;
  margin-bottom: 29px;
}
.tow .box .top p {
  font-size: 19px;
  line-height: 22px;
  color: #2b2b2b;
}
.tow .box .bottom {
  margin-top: 98px;
}
.tow .box .bottom .row {
  display: flex;
  margin-bottom: 18px;
}
.tow .box .bottom .row .item {
  height: 50px;
  flex: 1;
}
.tow .box .bottom .row .item:nth-child(2n) {
  margin: 0 16px;
}
.tow .box .bottom .row .item input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  padding-left: 18px;
  font-size: 18px;
  color: #b0b0b0;
}
.tow .box .bottom .row .item input::placeholder {
  font-size: 18px;
  color: #b0b0b0;
  font-family: auto;
}
.tow .box .bottom .row textarea {
  width: 100%;
  height: 180px;
  border: none;
  outline: none;
  padding: 16px 18px;
  font-size: 18px;
  color: #b0b0b0;
  resize: none;
}
.tow .box .bottom .row textarea::placeholder {
  font-size: 18px;
  font-family: auto;
  color: #b0b0b0;
}
.tow .box .bottom .botton {
  width: 153px;
  height: 49px;
  background-color: #004b94;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin: 47px auto 0;
  position: relative;
  cursor: pointer;
  border: 1px solid #004b94;
  transition: all 1s;
}
.tow .box .bottom .botton span {
  position: relative;
}
/* .tow .box .bottom .botton span::after {
  position: absolute;
  content: '';
  width: 100%;
  height: 1px;
  background-color: #fff;
  left: 0;
  bottom: -5px;
  transform: scaleX(0);
  transform-origin: left;
  transition: all 1s;
} */
.tow .box .bottom .botton::after {
  position: absolute;
  left: 50%;
  top: 50%;
  content: '';
  width: 182px;
  height: 62px;
  background-color: #004b94;
  transform: translate(-50%, -50%);
  border-radius: 31px;
  z-index: -1;
  opacity: 0.5;
  animation: amplify 1.5s linear infinite;
}
/* .tow .box .bottom .botton:hover span::after {
  transform: scaleX(1);
} */
@keyframes amplify {
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}
@media screen and (max-width: 1800px) {
  .one{
    max-width: 90%;
  }
  .tow .box{
    max-width: 90%;
  }
}
@media screen and (max-width: 1024px) {
  .one .list .item:nth-child(2) a {
    margin-bottom: 20px!important;
  }
  .one{
    padding: 20px 0 5px;
  }
  .one .list{
    flex-direction: column;
  }
  .one .list .item{
    margin: 0 0 15px 0!important;
    padding: 20px 3%;
  }
  .one .list .item h3{
    font-size: 20px;
  }
  .one .list .item p,.one .list .item p span{
    font-size: 14px!important;
    line-height: 25px;
  }
  .one .list .item span {
    font-size: 12px!important;
  }
  .tow .box .top p br {
    display: none;
  }
  .one .list .item .img{
    width: 30px;
    height: 30px;
  }
  .tow .bg img{
    position: absolute;
    min-height: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .tow .box{
    position: static;
    transform: none;
    margin: 50px auto;
  }
  .tow .box .top h2{
    font-size: 27px;
  }
  .tow .box .top p{
    font-size: 14px;
    line-height: 27px;
  }
  .tow .box .bottom {
    margin-top: 25px;
  }
  .tow .box .bottom .row{
    flex-direction: column;
    margin-bottom: 0;
  }
  .tow .box .bottom .row .item{
    flex: unset;
    margin: 0 0 15px 0!important;
  }
  .tow .box .bottom .row .item input{
    font-size: 14px;
  }
  .tow .box .bottom .row .item input::placeholder{
    font-size: 14px;
  }
  .tow .box .bottom .row textarea::placeholder{
    font-size: 14px;
  }
}

</style>


